import { compareStringsUtf16 } from './compareStringsUtf16';

/**
 * Deterministic query serialization: sort by param name, then value, so identical filter
 * sets always produce the same string.
 */
export const serializeURLSearchParamsStably = (urlParams: URLSearchParams): string => {
  const pairs: [string, string][] = [];
  urlParams.forEach((value, key) => {
    pairs.push([key, value]);
  });
  pairs.sort((a, b) => {
    const keyCmp = compareStringsUtf16(a[0], b[0]);
    if (keyCmp !== 0) {
      return keyCmp;
    }
    return compareStringsUtf16(a[1], b[1]);
  });
  const next = new URLSearchParams();
  pairs.forEach(([key, value]) => {
    next.append(key, value);
  });
  return next.toString();
};
